import { transformMinutesToHours } from '@app/utils';

export const handleServiceDuration = (Duration: number): string => {
  const hours =
    transformMinutesToHours(Duration).hours === '0'
      ? ''
      : `${transformMinutesToHours(Duration).hours} ` + 'ч.';
  const minutes =
    transformMinutesToHours(Duration).minutes === '00'
      ? ''
      : `${transformMinutesToHours(Duration).minutes} ` + 'мин.';

  return `${hours} ${minutes}`;
};
